import AssignedCaseDetail from '../shared/AssignedCaseDetail';

export default function CEOTicketDetail() {
  return <AssignedCaseDetail basePath="/hcms/ceo-tickets" title="CEO Ticket" />;
}
